// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__VbamK","row":"styles_row__2bR_0"};